var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEbz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 604 431",
    style: {
      enableBackground: "new 0 0 604 431"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#85E6C4;}\n\t.st1{fill:#6D44E5;}\n\t.st2{fill:#517CE3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.7,166.2h363.2l-40.8,74.4c-8.5,15.6-24.9,25.2-42.6,25.2H19.1L73.7,166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.8,314.4H585l-40.8,74.4c-8.5,15.6-24.9,25.2-42.6,25.2H167.2L221.8,314.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M221.8,18H585l-40.8,74.4c-8.5,15.6-24.9,25.2-42.6,25.2H167.2L221.8,18z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbz);
export default __webpack_public_path__ + "static/media/ebz.3cc27f8a566546a0c38b477c88e817eb.svg";
export { ForwardRef as ReactComponent };